import { motion } from "framer-motion";
import { HeartHandshake, PowerOff, PhoneCall, Coffee } from "lucide-react";
import { REVEAL } from "@/lib/site";

const steps = [
  { n: "01", icon: HeartHandshake, title: "Don't panic", text: "Take a breath. This happens to thousands of drivers every year — you're in good hands." },
  { n: "02", icon: PowerOff, title: "Turn off the engine", text: "Don't start the car. Keeping it off stops the wrong fuel circulating and prevents damage." },
  { n: "03", icon: PhoneCall, title: "Call Fuel Hero", text: "One quick call. Our specialist confirms your location and dispatches the nearest unit." },
  { n: "04", icon: Coffee, title: "Relax and wait", text: "We arrive, drain, flush and refuel — then you're safely back on the road." },
];

export const Steps = () => (
  <section id="steps" data-testid="steps-section" className="border-b border-black/10 bg-[#F5F3EF] py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5">
      <motion.div variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.4 }} className="mb-14 max-w-2xl">
        <span className="kicker text-[#1F7A6B]">The rescue plan</span>
        <h2 className="mt-3 font-heading text-3xl md:text-5xl leading-tight text-[#171717]">
          Four steps and you're back on the road
        </h2>
      </motion.div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            variants={REVEAL}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            transition={{ delay: i * 0.08 }}
            className="group rounded-2xl border border-black/10 bg-white p-7 shadow-soft-sm hover:-translate-y-1 transition-transform"
            data-testid={`step-card-${i + 1}`}
          >
            <div className="flex items-center justify-between">
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#E7DFCF] text-[#171717]">
                <s.icon strokeWidth={2} className="h-5 w-5" />
              </span>
              <span className="font-heading text-3xl text-black/10">{s.n}</span>
            </div>
            <h3 className="mt-5 font-heading text-xl text-[#171717]">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#171717]/65">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
